import {useEffect, useState} from 'react'
import ReactApexChart from 'react-apexcharts'
import { PostByAggWithAuth } from '../../utils/axios'


const LookerStatistics = () => {

    let [dataLast7dByTime, setDataLast7dByTime] = useState({streams:[], listeners:[], xasis:[]})
    let [titleChart, setTitleChart] = useState([])

    useEffect(() => {
    
        const url = 'looker/v1/report/find-last-7days-streams-by-time';
        PostByAggWithAuth({
          url: url,
          body: {
            'target': '7days'
          },
          onResponse: onSetDataResponse,
          onError: onSetDataError,
        });
    
        function onSetDataResponse(response) {
            const _data = response?.data?.data??[]
            if (_data.length < 1) return
            
            setDataLast7dByTime({
                streams: _data.map(item => item.total_streams),
                listeners: _data.map(item => item.total_listeners),
                xasis: _data.map(item => new Date(item.report_date).toLocaleDateString('en-CA', { timeZone: 'UTC' })),
            })

            const total_streams = _data.reduce((acc, curr) => acc + curr.total_streams, 0)
            const total_listeners = _data.reduce((acc, curr) => acc + curr.total_listeners, 0)
            setTitleChart([
                `Total Streams: ${total_streams}`, 
                `Total Listeners: ${total_listeners}`
            ])
        }
    
        function onSetDataError(error) {
          if (error.response.data.code === '4003400') {
            // navigate('/change-password');
          }
        }
    }, []);

    const series = [
        { name: 'Streams', data: dataLast7dByTime.streams },
        { name: 'Listeners', data: dataLast7dByTime.listeners },
    ]
    const options = {
        chart: { 
        id: 'bar-chart',
        toolbar: {
            show: false,
            tools: {
            download: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            selection: false
            },
        },
        zoom: {
            enabled: false
        } 
        },
        xaxis: { categories: dataLast7dByTime.xasis },
        title: {
            text: titleChart,
            align: 'left'
        }

    }
    return (
        <div className="col-xxl-12 col-md-6">
            <div className="card h-100">
                <div className="card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between">
                    <h6 className="fw-bold text-lg mb-0">Statistics</h6>
                </div>
                <div className="card-body">
                    <div className="">
                        <div>
                            <span className="text-secondary-light fw-normal text-xl">
                                Listeners & Streams
                            </span>
                        </div>
                        {
                            !!dataLast7dByTime.listeners.length && (
                                <ReactApexChart type="line" series={series} options={options} height={300} />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LookerStatistics